var _defs, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQNav6Selected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-q-nav-6{fill:#fff;}.cls-2-q-nav-6-selected{fill:#33b0ce;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "History-PB-02") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-q-nav-6",
    cx: 17,
    cy: 17,
    r: 17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-q-nav-6-selected",
    cx: 17,
    cy: 17,
    r: 15.59
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-6",
    d: "M20,20.49a5.41,5.41,0,0,1-.76.48.68.68,0,0,0-.3.9.72.72,0,0,0,.5.37.65.65,0,0,0,.41-.07,6.66,6.66,0,0,0,1-.61.69.69,0,0,0,.12-.95A.67.67,0,0,0,20,20.49Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-6",
    d: "M18,12.07a4.71,4.71,0,0,1,1.43.55.63.63,0,0,0,.23.08.72.72,0,0,0,.36,0h0a.77.77,0,0,0,.28-.23v0l1.14-1.73.08,0a.65.65,0,0,0,.69-.34A.67.67,0,0,0,22,9.43L21.13,9a.67.67,0,0,0-.82,1l-.77,1.17a6.43,6.43,0,0,0-1.26-.42.68.68,0,0,0-.8.52A.67.67,0,0,0,18,12.07Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-6",
    d: "M20.79,12.77a.67.67,0,0,0-.13.94,4.86,4.86,0,0,1,.43.68.66.66,0,0,0,.49.36.7.7,0,0,0,.42-.07.68.68,0,0,0,.29-.91,7.09,7.09,0,0,0-.55-.87A.67.67,0,0,0,20.79,12.77Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-6",
    d: "M15.77,21.42a4.67,4.67,0,0,1-1.44-.55.71.71,0,0,0-.47-.07H13.8a.61.61,0,0,0-.39.3L12.28,23h0a.68.68,0,1,0-.73,1.14l1.18.74A.77.77,0,0,0,13,25a.68.68,0,0,0,.47-1.24h0l.83-1.44a5.56,5.56,0,0,0,1.23.41h0a.67.67,0,0,0,.77-.53A.68.68,0,0,0,15.77,21.42Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-6",
    d: "M12.41,20.87a.65.65,0,0,0,.53-.15.67.67,0,0,0,.09-.95,5.68,5.68,0,0,1-.55-.83.68.68,0,1,0-1.2.62A6.41,6.41,0,0,0,12,20.63.72.72,0,0,0,12.41,20.87Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-6",
    d: "M12,14a.67.67,0,0,0-.89.34,5.54,5.54,0,0,0-.4,1.21.68.68,0,0,0,.52.8h0a.66.66,0,0,0,.76-.52,4.32,4.32,0,0,1,.31-.94A.67.67,0,0,0,12,14Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-6",
    d: "M10,12.6a.61.61,0,0,0,.28.11.67.67,0,0,0,.66-.28l.05-.08,1.45,1.14a.73.73,0,0,0,.31.14.7.7,0,0,0,.59-.2,4.8,4.8,0,0,1,1.24-.9.69.69,0,0,0,.3-.91.68.68,0,0,0-.91-.3,6.68,6.68,0,0,0-1.15.75l-1.06-.83.06-.08a.68.68,0,0,0-.17-.94.67.67,0,0,0-.94.17l-.88,1.27A.68.68,0,0,0,10,12.6Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-6",
    d: "M12.94,18a.68.68,0,0,0,.57-.76.69.69,0,0,0-.77-.58L10.07,17l0-.13a.67.67,0,0,0-1.33.21L9,18.49a.68.68,0,0,0,.56.57.5.5,0,0,0,.21,0,.66.66,0,0,0,.56-.72Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-6",
    d: "M15.09,15.05a.67.67,0,1,0-1.33-.21l-.11.65a.68.68,0,0,0,.57.77A.67.67,0,0,0,15,15.7Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-6",
    d: "M14.87,20.2a.67.67,0,0,0,.77-.56l.1-.65a.67.67,0,0,0-1.33-.21l-.1.65A.67.67,0,0,0,14.87,20.2Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-6",
    d: "M15.79,16.12l-.1.65A.67.67,0,1,0,17,17l.11-.65a.69.69,0,0,0-.56-.77A.68.68,0,0,0,15.79,16.12Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-6",
    d: "M19.55,15.15l.11-.65a.68.68,0,0,0-1.34-.22l-.1.65a.67.67,0,1,0,1.33.22Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-6",
    d: "M18.6,18.88a.69.69,0,0,0,.77-.56l.1-.66a.67.67,0,1,0-1.33-.21l-.1.65A.68.68,0,0,0,18.6,18.88Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-6",
    d: "M18.54,23.18h0l-.59-2.61a.68.68,0,0,0-1.32.3l.6,2.63h-.07a.68.68,0,0,0-.5.82.7.7,0,0,0,.55.51.82.82,0,0,0,.27,0l1.38-.34a.67.67,0,1,0-.31-1.31Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-6",
    d: "M23.71,15.11l-2.66.29a.68.68,0,0,0,0,1.34.48.48,0,0,0,.17,0l2.69-.29a.68.68,0,0,0,.55.55.61.61,0,0,0,.19,0,.67.67,0,0,0,.59-.75l-.08-.61h0l-.1-.8a.68.68,0,0,0-.75-.59.69.69,0,0,0-.59.75Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-6",
    d: "M15.17,10.26h.2l.16,2.67a.68.68,0,0,0,.57.63h.15a.69.69,0,0,0,.63-.72l-.16-2.69h0a.68.68,0,1,0-.11-1.35l-.69,0h0l-.73.06a.68.68,0,0,0-.06,1.34Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-6",
    d: "M25,19.72a.69.69,0,0,0-.94.19L24,20l-1.37-.82A6.83,6.83,0,0,0,23,18a.69.69,0,0,0-.52-.8.67.67,0,0,0-.8.52,4.9,4.9,0,0,1-.54,1.39.36.36,0,0,0,0,.11.58.58,0,0,0-.05.14.67.67,0,0,0,0,.2s0,0,0,.05a.66.66,0,0,0,.31.42h0l1.84,1.09a.67.67,0,0,0,.22.88.64.64,0,0,0,.26.1.66.66,0,0,0,.67-.29l.77-1.15A.69.69,0,0,0,25,19.72Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQNav6Selected);
export default __webpack_public_path__ + "static/media/q_nav_6_selected.16630ae1.svg";
export { ForwardRef as ReactComponent };